import React from "react";

import SelectPropertyEditor from "../SelectPropertyEditor";
import ExplicitPropertyEditorContainer from "../ExplicitPropertyEditorContainer";

function ChartTickMarksPropertyEditor(props) {
  const {
    shape,
    inputWidth,
    label = "Tick Marks",
    property = "tickMarks",
    ...other
  } = props;

  let values = [
    { key: "none", description: "None" },
    { key: "in", description: "Inside" },
    { key: "out", description: "Outside" },
    { key: "cross", description: "Cross" },
  ];

  return (
    <ExplicitPropertyEditorContainer {...other}>
      <SelectPropertyEditor
        label={label}
        values={values}
        shape={shape}
        inputWidth={inputWidth}
        property={property}
      ></SelectPropertyEditor>
    </ExplicitPropertyEditorContainer>
  );
}

export default ChartTickMarksPropertyEditor;
